export enum ErrorTypes {
  ApiError = "ApiError",
}